import { PreviewableSection } from '@/state/profile/profilePreview';

export type OutputLanguage = 'Deutsch' | 'Englisch';
export type ReanalyzableProfileSection = Extract<
PreviewableSection,
'basic' | 'skills' | 'educations' | 'certificates' | 'projects'
>;

const REANALYZE_SECTION_AREA_PROMPTS: Record<ReanalyzableProfileSection, string> = {
  basic: 'Only fill the \'summary\' and \'city/country\' part of the scheme. Set all other fields to "null".',
  skills: 'Only fill the \'skills_and_roles\' part of the scheme. Set all other fields to "null".',
  projects: 'Only fill the \'experience\' part of the scheme. Set all other fields to "null".',
  educations: 'Only fill the \'education\' part of the scheme. Set all other fields to "null".',
  certificates: 'Only fill the \'awards\' part of the scheme. Set all other fields to "null".',
};

const buildReanalyzeUserPrompt = (
  language: OutputLanguage,
  section: ReanalyzableProfileSection,
) => `Output language: ${language}.\n${REANALYZE_SECTION_AREA_PROMPTS[section]}`;

export default buildReanalyzeUserPrompt;
